import { z } from 'zod';

export const PermitsStepsScalarFieldEnumSchema = z.enum(['id','title','description','permit_id','due_date','assignee_id','order','permits_type_step_id','step_type','status','status_updated_at','reason','note','created_at','updated_at','inspections_type_id','active_inspection_id','official_permit_document','skippable','require_completion_message','automatic_complete','original_assignee_id','completed_user_id','documents_background_job_id','rowTimestamp']);

export default PermitsStepsScalarFieldEnumSchema;
